module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter",
    attrs: {
      "id": "section_chapter--num_1--seq_6"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_114620-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_114620-00001"
    }
  }, [_c('p', {
    staticClass: "title-num"
  }, [_c('i', [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "title-other"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "chapter_image.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_114620-00002"
    }
  }, [_c('span', {
    staticClass: "raisedcap"
  }, [_vm._v("T")]), _vm._v("he open solitude of the land above Falmouth beckoned fifteen-year-old Rowena. She rode with reckless abandon away from the house as though the devil himself pursued her. Her scarlet skirts covered the horse’s flanks and her unbound dark brown hair streamed behind her like a ship’s sprightly pennant. Her cheeks were poppy red, the colour heightening the intensity of her eyes, their blue-green aglow with the excitement and exhilaration of the ride.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00003"
    }
  }, [_vm._v("Did not her father call her a gypsy, a vagabond—all because she was too restless to be caged within the house? Her father was right. She did look like a gypsy and she was a gypsy at heart, for in her soul there was a wildness, a yearning to be free of all constraints, that made her feel like one.")])]), _c('p', {
    attrs: {
      "id": "rw-p_114620-00004"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("When the attack came it seemed to come from nowhere. She had no time to defend herself as she was dragged from her terrified horse and thrown to the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("ground. Wrenching herself away from her assailant, she shrieked, but he stifled the sound, clapping his hands over her mouth. She immediately began fighting, blindly thrashing in an iron grip that pinned her to the ground. She pushed against his chest to break free, but his arms became bonds, forcing her arms to her sides, and his mouth grinding down on hers prevented her cries of rage.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_114620-00005"
    }
  }, [_vm._v("Inwardly she raved. It was disgusting to be treated like this, absolutely disgusting. The depraved beast was intent on ravishment, without tenderness, without decency, as without mercy he began tearing at her clothes. Every twist of her body to escape his lust caused him to utter obscenities.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00006"
    }
  }, [_vm._v("Horror at the abuse gave her frenzied strength. She fought against his brutal strength, her mind somehow refusing to accept what was happening. Tears of outrage streamed from her eyes and her soul screamed against this violation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00007"
    }
  }, [_vm._v("‘Such spirit, such defiance, my little pretty,’ the man said, laughing low in his throat. ‘Your protests are useless. It will be better for you if you do not fight me, darlin’.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00008"
    }
  }, [_vm._v("Rowena recognised her attacker—it was Jack Mason, captain of the "), _c('i', [_vm._v("Dolphin")]), _vm._v(", her father’s ship. Earlier, when her father had introduced her to him, he had squeezed her hand and she had looked openly and without fear into his admiring eyes. His look was heavy lidded, beguiling, hungering, and had she not been a naïve fifteen-year-old, she would have been alarmed and wary, and would certainly not have been found riding alone in the open countryside.")])]), _c('p', {
    attrs: {
      "id": "rw-p_114620-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_114620-00010"
    }
  }, [_vm._v("Determined to be free from this nightmare, in one last desperate thrust she brought up her knee into his groin and shoved him away. With a yell of pain he doubled over on the ground, clutching his damaged manhood, and, taking her chance, Rowena wriggled away. On her hands and knees she looked down at him as he writhed in agony. He was seething, his eyes bulging with rage and filled with murder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00011"
    }
  }, [_vm._v("‘Think again if you intend to ravish me,’ she hissed, her eyes glaring her hatred. ‘Did you mean to frighten me?’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00012"
    }
  }, [_vm._v("‘I would enjoy frightening you,’ he gasped. ‘Indeed, I would heartily like to hear you scream for mercy.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00013"
    }
  }, [_vm._v("Rowena shot to her feet. ‘Do you think to convince me of your brutal ways? Ha!’ she retorted, laughing bitterly. ‘You are as I shall always remember you—on your knees where you belong.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00014"
    }
  }, [_vm._v("Captain Jack Mason’s cold grey eyes narrowed dangerously. ‘I warn you, Rowena Golding, do not laugh at me.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00015"
    }
  }, [_vm._v("‘I do laugh at you,’ Rowena sneered and flung a further taunt full into his face. ‘Do you think I would give myself to the likes of you? You are only fit to mop the decks on my father’s ship. Aye, Jack Mason, unfit company for gentlefolk—and, more’s the pity, you are too ignorant to know why.’")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_114620-00016"
    }
  }, [_vm._v("Turning from him, she hauled herself on to her horse and galloped away. The man on the ground watched her go, cold murder curling round his heart. ‘Go, you little bitch,’ he ground out. ‘But you’ll be dealt with, I’ll see to that.’")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150231be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408913727_chapter_01.vue
// module id = 69
// module chunks = 0